export class SharedPromise {
  private promises = new Map<string, Promise<unknown>>();

  execute<T>(key: string, factory: () => Promise<T>): Promise<T> {
    if (this.promises.has(key)) {
      return this.promises.get(key) as Promise<T>;
    }

    const promise = factory().finally(() => {
      this.promises.delete(key);
    });

    this.promises.set(key, promise);
    return promise;
  }
}
